<template>
  <div class="ex-info">
    <template v-if="list && list.items && list.items.length">
      <div class="my-item3">
        <Row :gutter="30">
          <Col span="8" v-for="(item, index) in list.items" :key="'my-item3' + index">
          <div class="my-item3-box">
            <div class="mi-content">
              <div class="mi-content-top">
                <div class="mi-content-top-left">
                  <img :src="item.headImg" class="logo" />
                  <p class="txt" :title="item.subtitle">{{item.subtitle}}</p>
                </div>
                <div class="mi-content-top-right" v-if="item.brand">
                  <div class="brand" :style="{color: item.brand.color}">{{item.brand.name}} {{item.type2 ? '/' + item.type2: ''}}</div>
                </div>
              </div>
              <div class="mi-content-date">提交时间：{{item.inTime | moment("YYYY/MM/DD HH:mm:ss")}}</div>
              <div class="mi-content-imglist" v-if="item.photo && item.photo.length">
                <template v-for="(i, idx) in item.photo">
                  <img class="img-item" :src="i" v-if="idx < 3" :key="'img-item' + idx" />
                </template>
              </div>
              <div class="mi-content-txt" style="padding-top:0;text-overflow:ellipsis;white-space: nowrap;display:block;">手机号：{{item.phone}}</div>
              <div :title="item.sourceName" class="mi-content-txt" style="padding-top:10px;text-overflow:ellipsis;white-space: nowrap;display:block;">
                来源：{{item.sourceName}}
                <template v-if="item.sourceType">
                  （{{item.sourceType}}）
                </template>
              </div>
              <div style="word-wrap:break-word;padding-top:5px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.information}}</div>
            </div>
            <div class="mi-tool">
              <div class="mi-tool-item" @click="changeStatus(item)">通过</div>
              <div class="mi-tool-line">|</div>
              <div class="mi-tool-item" @click="unPass(item)">不通过</div>
              <!-- <div class="mi-tool-item">
                    <Poptip confirm title="确认是否删除 ?" @on-ok="delItem(item)">删除</Poptip>
                  </div> -->
            </div>
          </div>
          </Col>
        </Row>
      </div>
      <div class="my-page" v-if="totalCount > pageSize" style="text-align:center;padding: 20ppx;">
        <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
      </div>
    </template>
    <div class="u-empty" v-else style="margin: 30px;">暂无数据</div>

    <iModal v-model="unShow" title="审核不通过" width="600px;" @on-cancel="close">
      <div class="info-content-editor">
        <Form ref="formInline2" :label-width="130" :model="formInline2" :rules="ruleInline2">
          <FormItem label="驳回原因：" prop="remark">
            <Input type="textarea" :rows="4" v-model="formInline2.remark" placeholder="请输入驳回原因" />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="unPassLast('formInline2')">确定</Button>
        <Button @click="close()">取消</Button>
      </div>
    </iModal>

  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "supply-user-check",
  props: {
    searchField: {
      type: String,
      default () {
        return "";
      }
    },
  },
  data () {
    return {
      unNewId: "",
      unShow: false,
      formInline2: {
        remark: "",
      },
      ruleInline2: {
        remark: [
          { required: true, message: "请输入驳回原因", trigger: "blur" },
        ],
      },

      list: null,
      pageSize: 12,
      list2: [],
      pageIndex: 1,
      totalCount: 0
    };
  },
  created () {
    this.init();
  },
  computed: {
    option () {
      return {
        // ExhibitionId: this.exhibitionInfo.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 0,
                  Label: "statusId",
                  Value: 0
                }
              },
              {
                type: 1,
                wheres: {
                  WhereOperator: 0,
                  Label: "fromType",
                  Value: 1
                }
              },
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "information",
                  Value: `%${this.searchField || ''}%`
                }
              }
            ]
          }
        }
      };
    },
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  methods: {
    ...mapActions({
      getReleaseType: "momentModule/getReleaseType",
      getReleaseByExhibition: "releaseModule/getReleaseByExhibition",
      delRelease: "releaseModule/delRelease",
      editReleaseStatus: "releaseModule/editReleaseStatus"
    }),
    reload () {
      this.pageIndex = 1;
      this.init();
    },
    async init () {
      let listData = await this.getReleaseType(this.exhibitionInfo.id);
      if (listData && listData.length) {
        this.list2 = listData;

      }
      let exData = await this.getReleaseByExhibition(this.option);
      if (exData) {
        this.list = exData;
        this.list.items.map(c => {
          if (c.typeInfo) c.typeInfo = JSON.parse(c.typeInfo);
          if (c.photo && c.photo.indexOf("[") !== -1)
            c.photo = JSON.parse(c.photo);
          this.list2.forEach(v => {
            if (v.id === c.typeId) {
              c.brand = v;
            }
          });
        });
        this.pageSize = exData.pageSize;
        this.pageIndex = exData.pageIndex;
        this.totalCount = exData.totalCount;
      }
    },
    async delItem (item) {
      let result = await this.delRelease(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    async changeStatus (item) {
      const req = {
        Id: item.id,
        StatusId: 1
      };
      let result = await this.editReleaseStatus(req);
      if (result.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        this.$Message.error("操作失败，请重新尝试");
      }
    },
    changePage (e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize;
      this.init();
    },


    unPass (e) {
      this.unShow = true;
      this.unNewId = e.id;
    },
    async unPassLast (name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        Id: this.unNewId,
        StatusId: -1,
        AuditRemark: this.formInline2.remark,
      };
      let bool = await this.editReleaseStatus(req);
      if (bool && bool.successed) {
        this.$Message.success("操作成功！");
        this.close();
        this.init();
      } else {
        this.$Message.error("操作失败，请重试！");
      }
    },
    close () {
      this.unShow = false;
      this.formInline2.remark = "";
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
  },
  destroyed () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style scoped lang="scss">
.ex-info {
  &-top {
    width: 100%;
    min-height: 100px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    padding: 20px 24px 0 36px;
    &-l {
      height: 100%;
      display: flex;
      flex-direction: column;
      .s1 {
        flex: 1;
        font-size: 14px;
        color: #8c8c8c;
      }
      .h1 {
        flex: 1;
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }
      .s2 {
        flex: 1;
        font-size: 14px;
        color: #333;
      }
    }
    &-r {
      &-box {
        width: 150px;
        height: 80px;
        border: 1px dashed #1890ff;
        background-color: #e7f4ff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .I1 {
          font-size: 16px;
          font-weight: bold;
          color: #1890ff;
        }
        .s3 {
          font-size: 14px;
          color: #1890ff;
          margin-left: 9px;
        }
      }
    }
  }
  &-content {
    min-width: 1000px;
    padding: 30px;
    padding-bottom: 50px;
  }
  &-list {
    width: 100%;
    display: inline-block;
    background-color: #fff;
    margin-bottom: 30px;
    &-img {
      width: 100%;
      padding-bottom: 66.666667%;
      position: relative;

      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
    &-title {
      padding-left: 10px;
      font-size: 14px;
      color: #1a1a1a;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 31px;
      background: #fff;
      height: 66px;
      padding: 10px 10px 7px 12px;
    }
    &-time {
      width: 300px;
      min-height: 27px;
      padding-left: 10px;
      font-size: 14px;
      color: #fe791e;
    }
  }
}
.pro {
  &-tool {
    display: flex;
    height: 48px;
    align-items: center;
    justify-content: space-around;
    background-color: #f7f9fa;

    &-item {
      flex: 1;
      line-height: 48px;
      font-size: 14px;
      color: #808080;
      cursor: pointer;
      text-align: center;
      &:hover {
        color: #1890ff;
      }

      &.z-del {
        &:hover {
          color: #f00;
        }
      }
    }

    &-line {
      background-color: #e8e8e8;
      font-size: 20px;
      width: 1px;
      height: 22px;
    }
  }
}
</style>